import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HistoricoAccesoFichero } from '../../../core/model/file';
import { Page } from '../../../core/model/page';
import { IPagination } from '../../../core/model/pagination';
import { FileDownloaderService } from '../../../core/services/file-downloader.service';

@Component({
  selector: 'app-historico-fichero',
  templateUrl: './historico-fichero.component.html',
  styleUrls: ['./historico-fichero.component.css']
})
export class HistoricoFicheroComponent implements OnInit {

  @ViewChild('tableFileHistory') table: any;

  @Input() expedienteId: number;
  @Input() GUID: string;
  @Input() historicoAccesoFichero: HistoricoAccesoFichero[];

  @Input() set isAccessFileHistoric(isAccessFileHistoric: boolean) {
    if (isAccessFileHistoric && !this.historicoAccesoFichero) {
      this.getAccessFileHistory();
    }
  }

  @Output() historicoAccesoFicheroChange = new EventEmitter<HistoricoAccesoFichero[]>();

  isLoadingData: boolean;

  page = new Page();

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  constructor(private fileDownloaderService: FileDownloaderService) { }

  ngOnInit() {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  onResizedTable(event: any): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getAccessFileHistory();
  }

  getAccessFileHistory() {
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + (+this.page.size);

    this.isLoadingData = true;
    this.fileDownloaderService.getAccessFileHistoric(this.GUID, inicio, fin)
      .subscribe((data: IPagination<HistoricoAccesoFichero>) => {
        if (data) {
          this.historicoAccesoFichero = data.dataList;
          this.historicoAccesoFicheroChange.emit(this.historicoAccesoFichero);
          this.page.totalElements = data.totalResults;
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
         }
        this.isLoadingData = false;
      });
  }

}
